export default "__VITE_ASSET__7Eue2KhH__"